import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putModulesModuleIDQuestions,
  type SaveModuleQuestionsRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { MODULES_QUERY_KEYS } from "Modules/Api/Queries/queryKeys";

export function useSaveModuleQuestionsMutation(moduleID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveModuleQuestionsRequest) =>
      putModulesModuleIDQuestions(request, moduleID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: MODULES_QUERY_KEYS.questions(moduleID),
      });
    },
  });
}
